import React from 'react';
import { IRolesDTO } from '../../../../api/roles.dao';
import Text from '../../../global/text/text';
import './role-list-item.scss';
import { FormattedMessage } from 'react-intl';
import DefaultButton from '../../../global/default-button/default-button';
import classnames from 'classnames';
import { RoleFormPermissionsContainer } from '../../_role-form/role-form';
import { Component } from '../../../../infrastructure/type-extensions';
import { editText } from '../../../../constants/common-labels.constants';

interface IProps extends IRolesDTO {
    handlePermissionsClick: <T extends { id: string; roleName: string }>(
        title: string, roleId: string, HostComponent: Component<T>, isExpandedByDefault: boolean
    ) => void;
    handleEditRoleClick: (linkName: string) => void;
    isRoleSelected?: boolean;
    isPermissionSelected?: boolean;
}

const RoleListItem = (props: IProps) => {
    const { name, description, linkName, handleEditRoleClick, handlePermissionsClick, isRoleSelected, isPermissionSelected } = props;

    const onPermissionsClick = () => {
       handlePermissionsClick(
            name,
            linkName,
            RoleFormPermissionsContainer,
            true
        );
    };

    const roleEffectClasses = classnames({
        active: isRoleSelected || isPermissionSelected,
        hoverable: !isRoleSelected && !isPermissionSelected,
    });

    return (
        <tr className='role-item' onDoubleClick={onPermissionsClick}>
            <td className={roleEffectClasses}>
                <div className='role-item__column role-item__name'>
                    <div className='role-item__name-content'>
                        <Text
                            className='role-item__text'
                            message={name}
                            withEllipsis
                        />
                    </div>
                    <DefaultButton
                        className='visible-while-hovered'
                        modifier={['slim', 'link']}
                        text={editText()}
                        onClick={() => handleEditRoleClick(linkName)}
                    />
                </div>
            </td>
            <td className={roleEffectClasses} onDoubleClick={onPermissionsClick}>
                <div className='role-item__column role-item__description'>
                    <div className='role-item__description-content'>
                        <span className='role-item__text' title={description}>
                            {description}
                        </span>
                    </div>
                    <DefaultButton
                        className='visible-while-hovered'
                        modifier='slim'
                        text={
                            <FormattedMessage
                                id='oe.common.permissions'
                                description='Label text'
                                defaultMessage='Permissions'
                            />
                        }
                        onClick={onPermissionsClick}
                    />
                </div>
            </td>
        </tr>
    );
};

export { RoleListItem };
